import { useLocation, Link as RouterLink } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex flex-wrap items-center gap-1 text-sm">
          <li>
            <RouterLink to="/" className="text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
              首页
            </RouterLink>
          </li>
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1">
              <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
              {item.href ? (
                <RouterLink to={item.href} className="text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.label}
                </RouterLink>
              ) : (
                <span className="text-foreground-950 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}